import React from "react";

const FooterSection = ({ footerText }) => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <span className="footer-text-section fw-bold">{footerText}</span>
          <div className="footer-circle"></div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
